module.exports = __webpack_public_path__ + "img/template_placeholder_red.536c478.png";